import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, ListItem } from '@material-ui/core';
import ChevronDownIcon from '../icons/ChevronDown';
import ChevronRightIcon from '../icons/ChevronRight';

const NavItem = (props) => {
  const { active, children, depth, icon, info, open: openProp, path, title, noncollapsable, ...other } = props;
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 12;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  // Branch
  if (children && !noncollapsable) {
    return (
      <ListItem
        disableGutters
        sx={{ display: 'block', py: 0 }}
        key={`${title}-${depth}-li`}
        {...other}
      >
        <Button
          endIcon={!open ? <ChevronRightIcon fontSize="small" /> : <ChevronDownIcon fontSize="small" />}
          onClick={handleToggle}
          startIcon={icon}
          sx={{
            color: 'text.primary',
            fontWeight: 600,
            fontSize: '18px',
            justifyContent: 'flex-start',
            pl: `${paddingLeft}px`,
            pr: '8px',
            py: '12px',
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
            borderRadius: '0',
          }}
          variant="text"
        >
          <Box sx={{ flexGrow: 1 }}>
            {title}
          </Box>
          {info}
        </Button>
        <Collapse in={open}>
          {children}
        </Collapse>
      </ListItem>
    );
  } else if (children && noncollapsable) {
    return (
      <ListItem disableGutters key={`${title}-${depth}-li`} sx={{ display: 'block', py: 0 }}>
        <Button
          // component={path && RouterLink}
          startIcon={icon}
          sx={{
            borderRadius: '0px',
            color: 'text.primary',
            fontWeight: 600,
            fontSize: '18px',
            justifyContent: 'flex-start',
            textAlign: 'left',
            pl: `${paddingLeft}px`,
            pr: '8px',
            py: '12px',
            textTransform: 'none',
            width: '100%',
            ...(active && {
              color: 'primary.main',
              backgroundColor: 'primary.activeNav',
              fontWeight: 'fontWeightBold',
              '& svg': {
                color: 'primary.main'
              }
            })
          }}
          variant="text"
        // to={path}
        >
          <Box sx={{ flexGrow: 1 }}>
            {title}
          </Box>
          {info}
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          {children}
        </Box>
      </ListItem>
    );
  }


  // Leaf
  return (
    <ListItem disableGutters key={`${title}-${depth}-li`} sx={{ display: 'flex', py: 0 }}>
      <Button
        component={path && RouterLink}
        startIcon={icon}
        sx={{
          borderRadius: '0px',
          color: 'text.primary',
          fontWeight: 600,
          fontSize: '18px',
          justifyContent: 'flex-start',
          textAlign: 'left',
          pl: `${paddingLeft}px`,
          pr: '8px',
          py: '12px',
          textTransform: 'none',
          width: '100%',
          ...(active && {
            color: 'primary.main',
            backgroundColor: 'primary.activeNav',
            fontWeight: 'fontWeightBold',
            '& svg': {
              color: 'primary.main'
            }
          })
        }}
        variant="text"
        to={path}
      >
        <Box sx={{ flexGrow: 1 }}>
          {title}
        </Box>
        {info}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired
};

NavItem.defaultProps = {
  active: false,
  open: false
};

export default NavItem;
